// FIXME: 正規表現ライブラリを使ったほうがいい。そのほうが保守性と信頼性が向上する。
export const specialStringRegex = /[-/\\^$*+?.()|[\]{}]/g;
export const nameRegex = /\S+/;
// カタカナと中黒・長音符・句読点などに加えて半角スペースを許容
// 半角スペースはバリデーション前の正規化で先頭/末尾トリム・連続スペース圧縮を行う前提
export const katakanaRegex = /^([\u3001-\u301C\u30A1-\u30F6\u30FB-\u30FE ])+$/m;

// 氏名(カナ)向けのスペース正規化
// - 全角スペースを半角スペースに変換
// - 先頭と末尾のスペースをトリム
// - 連続する半角スペースは1つに圧縮
export const normalizeKanaName = (input: string): string => {
  if (!input) return input;
  let s = input.replace(/\u3000/g, " "); // 全角スペース→半角スペース
  s = s.replace(/ {2,}/g, " "); // 連続半角スペースを1つに
  s = s.trim(); // 前後トリム
  return s;
};
export const urlRegex =
  /https?:\/\/[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+$/;
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
export const phoneNumberRegex = /^[0-9]{10,11}$/;
export const cellPhoneNumberRegex = /^[0-9]{11}$/;
export const phoneNumberEnRegex = /^\+81\d{9,13}$/;
export const verifyCodeRegex = /^[0-9]{6}$/;
export const patientNumberRegex = /^\d+$/;
export const priceRegex = /^([1-9]\d*|0)$/;
export const bankAccountNumberRegex = /^\d{7}$/;
export const branchCodeRegex = /^\d{3}$/;
export const postalCodeRegex = /^(\d{7})$/;
export const addressRegex = /\S+/;
export const address_2Regex = /^[0-9-]+$/;
export const onChangeCatchCopyRegex = /^.{0,30}$/;
export const symbolRegex =
  /[!"#$%&'()☆＊※@☆*+\-.,/:;<=>?@＠[\\\]^_`{|}~【】￥「」]/g;
export const percentRegex = /^[1-9][0-9]?$/;
//const halfSizeNumber = /^([1-9]\d*|0)(\.\d{1,2})?$/;
export const halfSizeNumber = /^[0-9]+$/;
export const decimalNumber = /^[0-9]+(\.[0-9]+)+$/; // 浮動小数点を許容
export const atLeast8HhalfSizeNumberAlphanumericCharacters =
  /^([a-zA-Z0-9!-/:-@¥[-`{-~]{8,256})$/; // 半角英数字8文字以上

/*export const isMatchValidation = (name: string, data: any) => {
  if (data !== '') {
    switch (name) {
      case 'name':
      case 'title':
      case 'nickName':
      case 'lastNameKanji':
      case 'firstNameKanji':
      case 'occupation': {
        if (specialStringRegex.test(data)) {
          return false;
        } else {
          return true
        }
      }
      case 'empty': {
        if (data === '') {
          return false;
        } else {
          return true
        }
      }
      case 'katakana':
      case 'lastNameKana':
      case 'firstNameKana':
      case 'bankAccountHolder': {
        if (katakanaRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'url': {
        if (urlRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'email': {
        if (emailRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'phoneNumber': {
        if (phoneNumberRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'phoneNumberEn': {
        if (phoneNumberEnRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'halfSizeNumber': {
        if (halfSizeNumber.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'decimalNumber': {
        if (decimalNumber.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'verifyCode': {
        if (verifyCodeRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'patientNumber': {
        if (patientNumberRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'regularPrice':
      case 'memberPrice':
      case 'membershipPrice':
      case 'backNumberPrice':
      case 'forFreeUserPrice':
      case 'forSubscriberPrice':
      case 'defaultStock': {
        if (priceRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'bankAccountNumber': {
        if (bankAccountNumberRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'branchCode': {
        if (branchCodeRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'postalCode': {
        if (postalCodeRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'address_2': {
        if (address_2Regex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'onChangeCatchCopy': {
        if (onChangeCatchCopyRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'symbol': {
        if (symbolRegex.test(data)) {
          return true;
        }
        return false;
      }
      case 'percent': {
        if (percentRegex.test(data)) {
          return true;
        } else {
          return false;
        }
      }
      case 'previousPassword':
      case 'proposedPassword':
      case 'confirmationProposedPassword':
        {
          if (atLeast8HhalfSizeNumberAlphanumericCharacters.test(data)) {
            return true;
          } else {
            return false;
          }
        }
      default: {
        break;
      }
    }
  } else {
    return false;
  }
  return false;
};*/
